import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS } from 'styles/constants';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

export const StepContainer = styled.li<{ active: boolean }>`
  border-top: 1px solid;
  scroll-margin-top: 115px;
  margin-bottom: ${SPACER.medium};
  padding-top: ${SPACER.small};

  svg {
    transform: rotate(${({ active }) => (active ? '180deg' : '0deg')});
  }

  ${MEDIA_QUERIES.mdUp} {
    border: none;
    margin: 0;
    max-width: 7.5rem;
    padding: 0;
    transition: max-width 0.5s ease-in-out 0.15s;

    ${({ active }) =>
      active
        ? `
          max-width: calc(100% - ((7.5rem * 3) + 3rem));
        `
        : ''}
  }

  ${MEDIA_QUERIES.xlUp} {
    max-width: 12.5rem;

    ${({ active }) =>
      active
        ? `
          max-width: calc(100% - ((12.5rem * 3) + 4.5rem));
        `
        : ''}
  }
`;

export const ExpandRow = styled.div`
  ${MEDIA_QUERIES.mdUp} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ExpandRowContent = styled.div`
  display: flex;
`;

export const DesktopImageContainer = styled.div<{ active: boolean }>`
  ${desktopOnly()}
  height: 7.5rem;
  margin-bottom: ${SPACER.medium};
  width: 100%;

  > div {
    max-height: 7.5rem;
    min-height: 7.5rem;
    width: 100%;
  }

  ${MEDIA_QUERIES.xlUp} {
    height: 12.5rem;
    margin-bottom: ${SPACER.large};

    > div {
      max-height: 12.5rem;
      min-height: 12.5rem;
    }
  }
`;

export const StepNumber = styled.span`
  color: ${LOCAL_COLORS.surfaceWhite};
  font-size: 1rem;
  font-weight: 700;
  line-height: 150%;
  margin-right: 0.375rem;

  ${MEDIA_QUERIES.mdUp} {
    font-family: var(--header-font);
    font-size: 2.5rem;
    line-height: 90%;
    margin-right: ${SPACER.medium};
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 6rem;
  }
`;

export const StepHeader = styled.h2`
  color: #ffffff;
  font-size: 1rem;
  line-height: 150%;

  ${MEDIA_QUERIES.mdUp} {
    flex-shrink: 0;
    font-size: 1rem;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.03rem;
    width: 4.25rem;
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 1.5rem;
    width: 6.875rem;
  }
`;

export const iconStyles = css`
  ${mobileOnly()}
  transition: transform 200ms ease-in-out;
  margin-left: auto;

  circle {
    fill: transparent;
    stroke-width: 0.1875rem;
  }
`;

const expandContentDisplay = (active: boolean) => `
  display: ${active ? 'block' : 'none'};
`;

export const DesktopExpandContent = styled.div<{ active: boolean }>`
  ${desktopOnly()}
  ${({ active }) => (active ? 'max-width: 100%;' : '')}

  div {
    max-height: 6.875rem;
    ${({ active }) =>
      active
        ? `
          transition: opacity 0.35s ease-in-out 0.65s;
          opacity: 1;
        `
        : `
          transition: opacity 0.15s ease-in-out;
          overflow: hidden;
          opacity: 0;
        `}
  }
`;

export const MobileExpandContent = styled.div<{ active: boolean }>`
  ${mobileOnly()}
  ${({ active }) => expandContentDisplay(active)}
  margin: ${SPACER.medium} 0;
`;

export const StepBody = styled.div`
  color: ${LOCAL_COLORS.surfaceWhite};
  line-height: 132%;
  margin-bottom: ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    font-size: 0.875rem;
    margin: 0 0 0 ${SPACER.medium};
    max-width: 100%;
  }

  @media (min-width: 1300px) {
    font-size: 1rem;
    margin: 0 ${SPACER.large};
  }
`;

export const MobileImageContainer = styled.div`
  ${mobileOnly()}
  margin-bottom: ${SPACER.xlarge};
  width: 100%;

  > div {
    width: 100%;
  }
`;
